import { useState } from 'react';
import { Box, Tab, Tabs, Typography } from '@mui/material';
import MainCard from 'ui-component/cards/MainCard';
import CronogramaAnual from './CronogramaAnual';
import CronogramaAnualView from './CronogramaAnualView';

function TabPanel({ children, value, index, ...other }) {
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`cronograma-tabpanel-${index}`}
            aria-labelledby={`cronograma-tab-${index}`}
            {...other}
        >
            {value === index && <Box sx={{ pt: 3 }}>{children}</Box>}
        </div>
    );
}

function a11yProps(index) {
    return {
        id: `cronograma-tab-${index}`,
        'aria-controls': `cronograma-tabpanel-${index}`,
    };
}

const CronogramaAnualTabs = ({ ...others }) => {
    const [value, setValue] = useState(0);

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    return (
        <MainCard title="Cronograma Anual de Manutenção">
            <Box sx={{ width: '100%' }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
                    <Tabs value={value} onChange={handleChange} aria-label="Cronograma Anual tabs">
                        <Tab label="Upload" {...a11yProps(0)} />
                        <Tab label="Calendário" {...a11yProps(1)} />
                    </Tabs>
                </Box>
                <TabPanel value={value} index={0}>
                    <CronogramaAnual />
                </TabPanel>
                <TabPanel value={value} index={1}>
                    <CronogramaAnualView />
                </TabPanel>
            </Box>
        </MainCard>
    );
};

export default CronogramaAnualTabs;
